/**
 * Public 3D viewer engine for customiser, collection View in 3D, and contained CMS model-viewer blocks.
 *
 * Section-backdrop (`sceneLayerMode: 'section-backdrop'`) blocks always use legacy ModelViewer
 * regardless of this flag until entrance Hero / backdrop migration.
 *
 * Rollback: set to `'modelViewer'` to restore legacy ModelViewer on the surfaces above.
 */
export type PublicViewerEngine = 'vaseStage3d' | 'modelViewer';

export const PUBLIC_VIEWER_ENGINE: PublicViewerEngine = 'vaseStage3d';

/** Alias — same engine as {@link PUBLIC_VIEWER_ENGINE}. */
export const PRODUCT_VIEWER_ENGINE = PUBLIC_VIEWER_ENGINE;
